import { BrowserRouter } from 'react-router-dom';
import { useState } from 'react';

import { AppRoutes } from './routes';
import { ToastProvider } from './components/UI/ToastManager';
import { loginRequest } from './utils/graphqlRequest';


export default function App() {
  const [loggedIn, setLoggedIn] = useState(() => !!localStorage.getItem('authToken'));

  const logIn = async (email: string, password: string) => {
    try {
      await loginRequest(email, password);
      setLoggedIn(true);
    } catch (error) {
      // handle login error
    }
  };

  const logOut = () => {
    localStorage.removeItem('authToken');
    setLoggedIn(false);
  };

  return (
    <ToastProvider>
      <BrowserRouter>
        <AppRoutes isAuthenticated={loggedIn} onLogin={logIn} onLogout={logOut} />
      </BrowserRouter>
    </ToastProvider>
  );
}
